import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Layout from "../../components/Layout/Layout"
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb"
import Typography from "../../components/UI/Typography/Typography"
import Image from "../../components/UI/Image/Image"
import Link from "../../components/UI/Link/Link"
import ImageCardsLayout from "../../components/ImageCardsLayout/ImageCardsLayout"
import TextContent from "../TextContent/TextContent"
import axios from "axios"
import ModalWrapper from "../../components/Wrappers/ModalWrapper/ModalWrapper"
import LoaderIcon from "../../assests/icons/LoaderIcon"
import useStaticData from "./StaticComponents"
import * as styles from "./jobDetails-tw-styles"
import { labels, SEARCH_JOB_BREADCRUMB } from "../../constants/label.constants"
import { gaEventClick } from "../../constants/gtm.constants"
import { getSourceDomain, getUTMParams } from "../../helpers/utils"

const JobDetails = props => {
  const [jobDetails, setJobDetails] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  let jobId
  let globalComponents
  let funcName = ""
  let staticData = useStaticData()
  let commonLoc = ""
  const style = styles.defaultStyle
  if (typeof window !== "undefined") {
    const paramValues = window?.location?.search?.split("&")
    jobId = paramValues[0].split("=")[1]
  }
  const FeatureImage = props?.seoDatas?.featuredImage?.url || ""
  const OGImage = props?.seoDatas?.ogImage?.url || ""

  useEffect(() => {
    if (typeof window !== "undefined") {
      let path = window?.location?.pathname.replace("/index.html", "")
      history.pushState(
        {},
        "",
        window.location.origin + path + window?.location?.search
      )
    }
    getJobDetails()
  }, [])

  // Fn to build static component data structure
  const buildGlobalComponents = () => {
    globalComponents = [
      {
        Header: {
          headerCollection: {
            items: staticData?.allContentfulHeader?.nodes,
          },
        },
      },
      {
        Footer: {
          footerCollection: {
            items: [
              {
                mainLinksCollection: {
                  items: staticData?.allContentfulFooter?.nodes[0]?.mainLinks,
                },
                socialLinksCollection: {
                  items: staticData?.allContentfulFooter?.nodes[0]?.socialLinks,
                },
                secondaryLinksCollection: {
                  items: [
                    {
                      linksCollection: {
                        items:
                          staticData?.allContentfulFooter?.nodes[0]
                            ?.secondaryLinks[0]?.links,
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      },
    ]
    return globalComponents
  }

  //to fetch job detail
  const getJobDetails = async () => {
    const headers = { appid: "dc1faad3-27ab-4345-aef0-877d345b77d2" }
    try {
      let result = await axios.post(
        process.env.GATSBY_JOBDETAIL_API,
        { siteId: "foodService", jobId: `${jobId}` },
        { headers: headers }
      )
      result && setIsLoading(false)
      setJobDetails(result?.data)
    } catch (error) {
      setIsLoading(false)
    }
  }

  const {
    Job_Posting_Description,
    Job_Posting_Title,
    Job_Requisition_ID,
    External_Apply_URL,
    External_Job_Path,
    Job_Family_Reference,
    Job_Posting_Start_Date,
    Time_Type_Reference,
    Job_Type_Reference,
    Job_Posting_Location_Data,
  } = jobDetails[0] || {}

  const { countriesList, filterData, languageList } =
    staticData?.contentfulJobFilter || {}
  const heroBannerDets =
    staticData?.allContentfulJobDetailWrapper?.nodes[0]?.jobDetailBanner
  const imageCardsLayout =
    staticData?.allContentfulJobDetailWrapper?.nodes[0]?.jobDetailCardsLayout
  const breadCrumb =
    staticData?.allContentfulJobDetailWrapper?.nodes[0]?.breadCrumb
  const textComponent =
    staticData?.allContentfulJobDetailWrapper?.nodes[0]?.textContent

  let additionalLocation = []

  Job_Posting_Location_Data?.length > 0 &&
    Job_Posting_Location_Data[0]?.Job_Posting_Additional_Location_Data?.length >
      0 &&
    Job_Posting_Location_Data[0]?.Job_Posting_Additional_Location_Data?.map(
      obj => {
        additionalLocation.push(obj?.Additional_Location_Reference[0]?.ID[1]?._)
      }
    )

  //fn to get location code for apply jobs
  const CountryCodeLocName = loc => {
    let countryCode = ""
    countriesList?.map(itm => {
      itm?.stateWithLocations?.length > 0 &&
        itm?.stateWithLocations?.map(el => {
          el?.locations?.map(e => {
            if (e.value == loc) {
              countryCode = itm?.countryCode
            }
          })
        })
      if (countryCode == "") {
        itm?.locations?.length > 0 &&
          itm?.locations?.map(ele => {
            if (ele.value == loc) {
              countryCode = itm?.countryCode
            }
          })
      }
    })
    return countryCode == "" ? [loc] : countryCode
  }

  // fn to display the location Name by using id
  const displayLocName = loc => {
    let locName = ""
    countriesList?.map(itm => {
      itm?.stateWithLocations?.length > 0 &&
        itm?.stateWithLocations?.map(el => {
          el?.locations?.map(e => {
            if (e.value == loc) {
              locName = [e.label, e?.value]
            }
          })
        })
      if (locName == "") {
        itm?.locations?.length > 0 &&
          itm?.locations?.map(ele => {
            if (ele.value == loc) {
              locName = [ele.label, ele?.value]
            }
          })
      }
    })
    return locName == "" ? [loc] : locName
  }

  const getLocDets = loc => {
    let locArr = loc
    let isArr = Array.isArray(loc)
    let currentLoc = []
    isArr
      ? locArr?.map(e => {
          currentLoc.push(displayLocName(e))
        })
      : currentLoc.push(displayLocName(loc))
    return currentLoc
  }

  //fn to display the function Name by id
  const getFuncName = lab => {
    let currentFunc = ""
    const functions = filterData?.selectFields?.jobFamily?.options
    functions?.map(itm => {
      if (itm?.value?.split("|")?.includes(lab)) {
        currentFunc = itm?.label
      }
    })
    funcName = currentFunc
    return currentFunc
  }

  //fn to format the date as mm/dd/yyyy
  const formatDate = dateStr => {
    const [year, month, day] = dateStr.split("-")
    const mon = month && month.replace("0", "")
    const formattedDay = day && day.replace("0", "")
    let newDate = `${mon}/${formattedDay}/${year}`
    return newDate
  }

  const jobDetailsData = {
    Title: Job_Posting_Title?.length > 0 ? Job_Posting_Title[0] : "",
    Function:
      Job_Family_Reference?.length > 0 &&
      getFuncName(
        Job_Family_Reference[0]?.ID && Job_Family_Reference[0]?.ID[1]?._
      ),
    Date:
      Job_Posting_Start_Date?.length > 0 &&
      formatDate(Job_Posting_Start_Date[0]),
    "Job ID": Job_Requisition_ID,
    "Work Schedule":
      Time_Type_Reference?.length > 0 &&
      Time_Type_Reference[0]?.ID &&
      Time_Type_Reference[0]?.ID[1]?._?.replace("_", " "),
    "Job Type":
      Job_Type_Reference?.length > 0 &&
      Job_Type_Reference[0]?.ID &&
      Job_Type_Reference[0]?.ID[1]?._,
    Location:
      Job_Posting_Location_Data?.length > 0 &&
      getLocDets(
        Job_Posting_Location_Data[0]?.Primary_Location_Reference[0]?.ID[1]?._
      ),
    "Additional Location(s)": getLocDets(additionalLocation),
    CountryCode:
      Job_Posting_Location_Data?.length > 0 &&
      CountryCodeLocName(
        Job_Posting_Location_Data[0]?.Primary_Location_Reference[0]?.ID[1]?._
      ),
  }

  let utmParams = ""
  if (typeof window !== "undefined" && window.Cookies) {
    utmParams = getUTMParams(window?.location?.search)
    if (utmParams) window.Cookies.set("utmParams", utmParams)
    else if (typeof window !== "undefined" && window.Cookies?.get("utmParams")) {
      utmParams = window.Cookies?.get("utmParams")
    }
  }

  let sourceSiteURL = null
  if (typeof window !== "undefined" && window.Cookies?.get("sourceSiteURL")) {
    sourceSiteURL = window.Cookies?.get("sourceSiteURL")
  } else if (
    typeof window !== "undefined" &&
    typeof document !== "undefined" &&
    window.Cookies
  ) {
    sourceSiteURL = document.referrer ? document.referrer : "Company_Website"
    window.Cookies.set("sourceSiteURL", sourceSiteURL)
  }

  const paradoxURL = externalLink => {
    var paradoxlink = externalLink
    const sourceUrl = getSourceDomain(sourceSiteURL, utmParams)
    var ProfId =
      jobDetails[0]?.["Hiring_Requirement_Data"]?.length > 0
        ? jobDetails[0]?.["Hiring_Requirement_Data"][0]
          ?.Job_Profile_Reference[0]?.ID[1]?._
        : ""
    if (
      jobDetailsData?.CountryCode === "US" &&
      labels?.Job_Profile_ID.includes(ProfId)
    ) {
      let jobID = Job_Requisition_ID
      paradoxlink =
        process.env.GATSBY_PARADOX_URL +
        jobID +
        `?${sourceUrl}${utmParams ? `&${utmParams}` : ""}`
    } else {
      let jobFamily = ""
      if (Job_Family_Reference[0]?.ID[1]?._) jobFamily = `jobFamily=${Job_Family_Reference[0]?.ID[1]?._}&`
      paradoxlink = paradoxlink + `?${jobFamily}${sourceUrl}${utmParams ? `&${utmParams}` : ""}`
    }
    return paradoxlink
  }

  const applyLink = {
    url:
      External_Apply_URL?.length > 0 ? paradoxURL(External_Apply_URL[0]) : "",
    label: "Apply Now",
    gaEventLabel: "Apply Now",
  }

  const getURL = val => {
    return `/careers/jobs?locationid=${val}`
  }

  //fn to display the job detail section
  const renderJobDetails = () => {
    return Object?.entries(jobDetailsData)?.map((key, index) => {
      if (key[0] == "Location" || key[0] == "Additional Location(s)") {
        return (
          <div key={index}>
            {key[0] == "Additional Location(s)" ? (
              key[1]?.length > 0 && <p>{key[0]}</p>
            ) : (
              <p>{key[0]}</p>
            )}
            <div className="flex flex-col w-[66.66%]">
              {key[1]?.map(
                (e, index) =>
                  e !== "" && (
                    <a
                      key={index}
                      href={e[1] == undefined ? getURL(e[0]) : getURL(e[1])}
                      className={style.jobDescLocationName}
                    >
                      <span className={style.jobDescLocationNameSpan}>
                        {e[0]}
                      </span>
                    </a>
                  )
              )}
            </div>
          </div>
        )
      } else {
        if (key[0] !== "CountryCode") {
          return (
            <div key={index}>
              <p>{key[0]}</p>
              <p>{key[1]}</p>
            </div>
          )
        }
      }
    })
  }

  //fn to display the language section
  const renderLanguageList = () => {
    function buildURL(val) {
      const url = External_Job_Path[0]
      const split = url.split("recruiting")
      let jobFamily = ""
      if (Job_Family_Reference[0]?.ID[1]?._)
        jobFamily = `jobFamily=${Job_Family_Reference[0]?.ID[1]?._}&`
      const sourceUrl = getSourceDomain(sourceSiteURL, utmParams)
      return split[0]
        ?.concat(val)
        ?.concat("/recruiting")
        ?.concat(split[1])
        .concat(`?${jobFamily}${sourceUrl}${utmParams ? `&${utmParams}` : ""}`)
    }
    return languageList?.map((itm, index) => {
      const link = {
        label: itm?.label,
        url: buildURL(itm?.value),
      }
      return (
        <div key={index}>
          <a
            rel="noreferrer"
            href={link?.url}
            target="_blank"
            data-action-detail="exit_job_via_language"
            className="event_external_link"
          >
            <img src={itm?.flagIcon}></img>
            {link?.label}
          </a>
        </div>
      )
    })
  }

  commonLoc =
    Job_Posting_Location_Data?.length > 0 &&
    getLocDets(
      Job_Posting_Location_Data[0]?.Primary_Location_Reference[0]?.ID[1]?._
    )

  const getOgUrl = () => {
    if (typeof window !== "undefined") {
      return (
        window?.location?.pathname?.replace("/index.html", "") +
        window?.location?.search
      )
    }
  }

  const seoDesc =
    commonLoc?.length > 0 ? `${Job_Posting_Title} in ${commonLoc[0][0]}` : ""

  const seoData = {
    metaTitle: `${seoDesc} | ${labels.metaTitle}`,
    metaDescription: `${labels.metaDesRecipe} ${seoDesc} ${labels.metaDes}`,
    ogTitle: `${seoDesc} | ${labels.metaTitle} `,
    title: `${seoDesc} | ${labels.metaTitle}`,
    pageType: "JobType",
    featuredImage: { url: FeatureImage },
    ogImage: { url: OGImage },
    ogUrl: getOgUrl(),
  }

  if (typeof window != "undefined" && funcName) {
    const jobFunctionLayer = window?.dataLayer?.find(
      layer => layer["job_function"]
    )
    !jobFunctionLayer && window.dataLayer.push({ job_function: funcName })
  }

  return (
    <Layout seoData={seoData} globalComponents={buildGlobalComponents()}>
      {isLoading && (
        <div className="loader">
          {" "}
          <ModalWrapper>
            <LoaderIcon />
          </ModalWrapper>
        </div>
      )}
      {jobDetails?.length > 0 ? (
        <div className={`${jobId}`}>
          <BreadCrumb
            {...breadCrumb}
            isRegionalBreadcrumb={true}
            regionalBreadcrumbsCollection={SEARCH_JOB_BREADCRUMB}
          />
          <div className="jobDetailsBannerWrap">
            <Image
              contentfulImage={heroBannerDets?.images?.imageDesktop?.file}
            />
            <div className={style.jobDetailBannerTextWrap}>
              <p className={style.jobDetailBannerText}>{funcName}</p>
              <h1 className={style.jobDetailBannerTitle}>
                {Job_Posting_Title}
              </h1>
              <p className={style.jobDetailBannerSubTitle}>
                {Job_Requisition_ID} |{jobDetailsData?.Location[0][0]}
                {additionalLocation?.length > 0 && (
                  <>
                    | {additionalLocation?.length} other location(s) available
                  </>
                )}
              </p>
              <div className={style.jobDetailBannerButtonRow}>
                <Link
                  className={style.jobDetailBannerButton}
                  url={
                    External_Apply_URL?.length > 0
                      ? paradoxURL(External_Apply_URL[0])
                      : ""
                  }
                  gaEventClass={gaEventClick}
                  label="APPLY NOW"
                  gaEventLabel="Apply Now"
                />
              </div>
            </div>
          </div>
          <div className={style.jobContainer}>
            <div className={style.leftContainer}>
              <Typography content={Job_Posting_Description[0]} />
              <Link {...applyLink} />
            </div>
            <div className={style.rightContainer}>
              <div className={style.jobDesc}>
                <h2>Job Details</h2>
                <div>{renderJobDetails()}</div>
                <Link {...applyLink} />
              </div>

              <div className={style.langOpts}>
                <h2>Language Options</h2>
                {renderLanguageList()}
              </div>
            </div>
          </div>

          <div>
            {imageCardsLayout?.cards?.length > 0 && (
              <ImageCardsLayout
                variant={imageCardsLayout?.variant}
                carditems={imageCardsLayout?.cards}
              />
            )}
          </div>
        </div>
      ) : (
        <div>
          <BreadCrumb
            {...breadCrumb}
            isRegionalBreadcrumb={true}
            regionalBreadcrumbsCollection={SEARCH_JOB_BREADCRUMB}
          />
          <div className="banner sec">
            <Image
              contentfulImage={heroBannerDets?.images?.imageDesktop?.file}
            />
          </div>
          <p>The Job is not available</p>
        </div>
      )}
      <TextContent
        shortDescription={textComponent?.shortDescription?.shortDescription}
      />
    </Layout>
  )
}

export default JobDetails

JobDetails.propTypes = {
  seoDatas: PropTypes.object,
}